import { render } from "./ApprenticeshipView.vue?vue&type=template&id=72eb3483&scoped=true"
const script = {}

import "./ApprenticeshipView.vue?vue&type=style&index=0&id=72eb3483&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72eb3483"]])

export default __exports__